import store from '~/Store';
import { showMenuItem } from '~/Actions/ActionApp';
import { CATEGORIES } from '~/const';
import AbstractPreloader from '~/core/AppInit/AbstractPreloader';
import { isDockyardEnabledForAccount } from '~/api/dockyard';
import { getStepByName, GUIDE_NAMES } from '~/components/WelcomePage/steps';
import { hideGuideStep } from '~/Actions/ActionAccount';

export default class DockyardPreloader extends AbstractPreloader {
    async load(): Promise<any> {
        isDockyardEnabledForAccount().then((isEnabled) => {
            if (isEnabled) {
                store.dispatch(showMenuItem(CATEGORIES.DOCKYARD));
            } else {
                const guide = getStepByName(GUIDE_NAMES.guide_dockyard);
                if (guide.isNeedToShown()) {
                    store.dispatch(hideGuideStep(guide));
                }
            }
        });
        return Promise.resolve(1);
    }
}
